export default "__VITE_ASSET__sw7MkjaH__"